<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapBaseMaterials"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.useAuth" type="primary" @click="batchOnShelves">启用</el-button>
        <el-button v-if="limits.nouseAuth" type="primary" @click="batchDownShelves">禁用</el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.updateAuth" type="primary" @click="batchUpdate(scope.row)">刷新单据</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.no" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.name" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="物料状态">
            <el-select v-model="filter.status" clearable placeholder="请选择物料状态">
              <el-option label="全部" value="-1"/>
              <el-option label="启用" value="10"/>
              <el-option label="禁用" value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="价格状态">
            <el-select v-model="filter.priceStatus" clearable placeholder="请选择价格状态">
              <el-option label="全部" value="-2"/>
              <el-option label="未审核" value="0"/>
              <el-option label="未维护" value="-1"/>
              <el-option label="已提交" value="10"/>
              <el-option label="未通过" value="20"/>
              <el-option label="已通过" value="30"/>
            </el-select>
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model.trim="filter.unit" placeholder="请输入单位" clearable/>
          </el-form-item>
          <el-form-item label="旧物料号">
            <el-input v-model.trim="filter.mappingMaterialNo" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
          <el-form-item label="厂家型号">
            <el-input v-model.trim="filter.manufacturerModel" placeholder="请输入厂家型号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <material-edit ref="materialEdit" @save-success="loadData"/>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import MaterialEdit from "./MaterialEdit";
  import MaterialTypeSelector from "./MaterialTypeSelector";

  export default {
    name: "MaterialList",
    components: {viewTable, MaterialEdit, MaterialTypeSelector},
    data() {
      return {
        limits: {
          editAuth: this.$auth(641),
          useAuth: this.$auth(638),
          nouseAuth: this.$auth(639),
          updateAuth: this.$auth(45),
        },
        filter: {
          no: "",
          name: "",
          materialTypeId: "",
          mrpType: "",
          feedingType: "",
          specification: "",
          manufacturerModel: "",
          vehicleName: "",
          status: "",
          priceStatus: "",
          unit: "",
          mappingMaterialNo: "",
        },
        selection: [],
        materialType: [],
        columnsProperty: [
          {
            key: "no",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.materialEdit.open(params.row, true);
                    },
                  },
                },
                params.row.no,
              );
            },
          },
          {
            key: "name",
            minWidth: 200,
          },
          {
            key: "zmyxh",
            minWidth: 200,
          },
          {
            key: "unit",
            width: 100,
          },
          {
            key: "mappingMaterialNo",
            width: 200,
            align: "center",
          },
          {
            key: "materialGroupNO",
            width: 100,
            align: "center",
          },
          {
            key: "mrpController",
            minWidth: 200,
          },
          {
            key: "softInfo",
            width: 100,
            align: "center",
          },
          {
            key: "manufacturerModel",
            width: 200,
            align: "center",
          },
          {
            key: "productDistribution",
            width: 100,
            align: "center",
          },
          {
            key: "productLayer",
            width: 100,
            align: "center",
          },
          {
            key: "procurementType",
            width: 100,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
      this.getAllTypeList();
    },

    methods: {
      getAllTypeList() {
        this.$http.get("basic", "materialTypes/getAllList").then((resp) => {
          if (resp.success) {
            this.materialType = resp.data;
            this.materialType.push({
              materialTypeName: "未设置",
              pkid: -2,
            });
          }
        });
      },

      selectMaterialType(row) {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.materialID);
        });
        if (row.id) {
          this.$http.get("basic", `materials/upDateMaterialType/${ids}/${row.id}`).then((resp) => {
            if (resp.success) {
              this.loadData();
              this.$message.success("物料类型绑定成功");
              this.selection = [];
            }
          });
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        this.$refs.materialEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "materials", row.materialID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      batchOnShelves() {
        let ids = [];
        this.selection.forEach(item => ids.push(item.id));
        this.$http.post("basic", "sapBaseMaterials/batchOnShelves", ids)
          .then(res => {
            if (res.success) {
              this.$message.success("启用成功");
              this.loadData();
            }
          });
      },

      batchDownShelves() {
        let ids = [];
        this.selection.forEach(item => ids.push(item.id));
        this.$http.post("basic", "sapBaseMaterials/batchDownShelves", ids)
          .then(res => {
            if (res.success) {
              this.$message.success("禁用成功");
              this.loadData();
            }
          });
      },

      batchUpdate(row) {
        this.$http.get("basic", `sapBaseMaterials/updateAllMaterial/${row.no}`).then(resp => {
          if (resp.success) {
            this.$Message.success("刷新成功");
          }
        });
      },
    },
  };
</script>







